import { render } from "./Contacts.vue?vue&type=template&id=c9ede462"
import script from "./Contacts.vue?vue&type=script&lang=ts"
export * from "./Contacts.vue?vue&type=script&lang=ts"
script.render = render

export default script